













import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { ITableSize } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component
export default class TableSizeEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITableSize) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITableSize) => T, defaultValue: T) => T;

  @Prop()
  scriptGroupKey: string;

  @Prop()
  isAlreadyLayouted: boolean;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get row(): number {
    return this.readPropertyOrDefault(s => s.row, 1);
  }

  get column(): number {
    return this.readPropertyOrDefault(s => s.column, 1);
  }

  get tableSize(): ITableSize {
    return this.readPropertyOrDefault(s => s, { row: 1, column: 1 });
  }

  set tableSize(value: ITableSize) {
    if (this.isAlreadyLayouted) {
      this.commonComponents.getScriptGroupEditor().updateEditor(this.scriptGroupKey, value.row, value.column);
    } else {
      this.writePropertyWhenValid(s => {
        s.row = value.row;
        s.column = value.column;
      });
    }
  }

  async showTableSizeEditDialog() {
    const dialog = this.commonComponents.getDialogs().getTableSizeEditDialog();
    const tableSize = await dialog.show(this.tableSize);
    if (!tableSize) { return; }
    this.tableSize = tableSize;
  }
}
